module.exports = __webpack_public_path__ + "media/images/map/ligne18-4f387714187e1edb6c7aab1d43856a44.png";